import { Bell, BellOff } from "lucide-react";
import { Button } from "@/components/ui/button";

type BellButtonProps = {
  isSnoozed: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: "sm" | "md";
  className?: string;
};

export const BellButton = ({
  isSnoozed,
  onClick,
  size = "md",
  className = "",
}: BellButtonProps) => {
  const iconSize = size === "sm" ? 14 : 16;

  return (
    <Button
      variant="ghost"
      size="sm"
      className={`h-8 w-8 p-0 ${isSnoozed ? "text-snooze-purple hover:text-snooze-purple/80" : "text-slate-400 hover:text-slate-600"} ${className}`}
      onClick={onClick}
      aria-label={isSnoozed ? "Manage snooze" : "Snooze notifications"}
    >
      {isSnoozed ? <BellOff size={iconSize} /> : <Bell size={iconSize} />}
    </Button>
  );
};
